export const API_CALL_STARTED = 'API_CALL_STARTED';
export const API_CALL_FINISHED = 'API_CALL_FINISHED';
export const API_CALL_FAILED = 'API_CALL_FAILED';
export const UPDATE_PAGE_FILTER = 'UPDATE_PAGE_FILTER';
export const ADD_OPEN_SPLIT_ORDER = 'ADD_OPEN_SPLIT_ORDER';
export const REMOVE_OPEN_SPLIT_ORDER = 'ADD_OPEN_SPLIT_ORDER';
export const TOGGLE_OPEN_SPLIT_ORDERS = 'TOGGLE_OPEN_SPLIT_ORDERS';
